<template>
<div class="row">
    <div class="col-lg-5 box-col-5">
        <div class="card">
            <div class="card-header pb-0">
                <div class="row">
                    <div class="col-9">
                        <h3>Finance</h3>
                    </div>
                    <div class="col-3 text-end">
                        <vue-feather class="text-muted" type="navigation"></vue-feather>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="chart-container">
                    <div id="columnchart">
                        <apexchart height="365px" :options="finance.options" :series="finance.series"></apexchart>
                    </div>
                </div>
            </div>
        </div>
    </div>

<div class="col-lg-7 box-col-7">
    <div class="card">
        <div class="card-header pb-0">
            <div class="row">
                <div class="col-9">
                    <h3>Order Status</h3>
                </div>
                <div class="col-3 text-end">
                    <vue-feather class="text-muted" type="shopping-bag"></vue-feather>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="chart-container">
                <div id="linechart"><apexchart height="365px" :options="order.options" :series="order.series"></apexchart></div>
            </div>
        </div>
    </div>
</div>
</div>
</template>

<script>
import wcharts from '../../../data/widgets/charts/wcharts'
export default {
    name: 'financeorderPage',
    data() {
        return {
            order: wcharts.OrderChart,
            finance: wcharts.FinanceChart
        }
    }
}
</script>
